import { ref, get, runTransaction } from 'firebase/database';
import { database } from '../firebaseConfig';

// Counts page views per day by device type (phone, tablet, desktop). Stored as counters only,
// so no personal information is recorded.

export const deviceTypeNow = () => {
  if (typeof window === 'undefined') return 'desktop';
  const ua = navigator.userAgent || '';
  if (/iPad|Tablet/i.test(ua) || (/Android/i.test(ua) && !/Mobi/i.test(ua))) return 'tablet';
  if (/Mobi|iPhone|iPod|Android/i.test(ua) || window.innerWidth < 768) return 'mobile';
  return 'desktop';
};

export const dayKey = (d = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const recordPageView = async () => {
  try {
    const device = deviceTypeNow();
    await runTransaction(ref(database, `deviceUsage/${dayKey()}/${device}`), (count) => (count || 0) + 1);
  } catch (err) {
    console.error('Could not record page view', err);
  }
};

// Returns the last `days` days as [{ day, mobile, tablet, desktop }], oldest first.
export const loadDeviceUsage = async (days = 30) => {
  const snap = await get(ref(database, 'deviceUsage'));
  const all = snap.exists() ? snap.val() : {};
  const out = [];
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date();
    d.setDate(d.getDate() - i);
    const key = dayKey(d);
    const row = all[key] || {};
    out.push({ day: key, mobile: row.mobile || 0, tablet: row.tablet || 0, desktop: row.desktop || 0 });
  }
  return out;
};
